export enum DashboardServiceActions {
  ALL = '*',
  Widgets = 'widgets',
  Layout = 'layouts',
}
